/**
 * Rug Shield Logo Components
 * Automatically adapts to dark/light mode
 */

// Logo icon only
export function Logo({ size = 40, darkMode = true }) {
  // Dark mode: dark background, black shield
  // Light mode: light background, white shield
  const bgColor = darkMode ? '#1a1a1a' : '#e5e5e5';
  const shieldColor = darkMode ? '#000000' : '#ffffff';
  const brandColor = '#ff5500';

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 200 200" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="100" cy="100" r="85" fill={bgColor}/>
      <path 
        d="m100 35 45 15v50c0 35-20 55-45 65-25-10-45-30-45-65V50z" 
        fill={shieldColor}
      />
      <path 
        d="m70 110 15-20 20 30 25-40" 
        fill="none" 
        stroke={brandColor} 
        strokeWidth="7" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <circle cx="130" cy="80" r="6" fill={brandColor}/>
    </svg>
  );
}

// Logo with wordmark
export function LogoWithText({ height = 40, darkMode = true }) {
  const bgColor = darkMode ? '#1a1a1a' : '#e5e5e5';
  const shieldColor = darkMode ? '#000000' : '#ffffff';
  const textColor = darkMode ? '#ffffff' : '#000000';
  const brandColor = '#ff5500';
  const subtitleColor = darkMode ? '#888888' : '#666666';
  
  const width = height * 4;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 320 80" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Logo icon scaled */}
      <g transform="translate(5, 5) scale(0.35)">
        <circle cx="100" cy="100" r="85" fill={bgColor}/>
        <path 
          d="m100 35 45 15v50c0 35-20 55-45 65-25-10-45-30-45-65V50z" 
          fill={shieldColor}
        />
        <path 
          d="m70 110 15-20 20 30 25-40" 
          fill="none" 
          stroke={brandColor} 
          strokeWidth="7" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <circle cx="130" cy="80" r="6" fill={brandColor}/>
      </g>
      
      {/* RUG text */}
      <text 
        x="85" 
        y="45" 
        fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif" 
        fontSize="28" 
        fontWeight="800" 
        fill={textColor}
      >
        RUG
      </text>
      
      {/* SHIELD text - orange */}
      <text 
        x="152" 
        y="45" 
        fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif" 
        fontSize="28" 
        fontWeight="800" 
        fill={brandColor}
      >
        SHIELD
      </text>
      
      {/* Tagline */}
      <text 
        x="85" 
        y="65" 
        fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif" 
        fontSize="9" 
        fill={subtitleColor} 
        letterSpacing="1"
      >
        PREDICTION MARKET INSURANCE
      </text>
    </svg>
  );
}

// Compact header logo
export function HeaderLogo({ darkMode = true }) {
  const bgColor = darkMode ? '#1a1a1a' : '#e5e5e5';
  const shieldColor = darkMode ? '#000000' : '#ffffff';
  const textColor = darkMode ? '#ffffff' : '#000000';
  const brandColor = '#ff5500';

  return (
    <svg 
      width="160" 
      height="36" 
      viewBox="0 0 160 36" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Logo icon */}
      <g transform="translate(0, 0) scale(0.18)">
        <circle cx="100" cy="100" r="85" fill={bgColor}/>
        <path 
          d="m100 35 45 15v50c0 35-20 55-45 65-25-10-45-30-45-65V50z" 
          fill={shieldColor}
        />
        <path 
          d="m70 110 15-20 20 30 25-40" 
          fill="none" 
          stroke={brandColor} 
          strokeWidth="7" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <circle cx="130" cy="80" r="6" fill={brandColor}/>
      </g>
      
      {/* RUG */}
      <text 
        x="42" 
        y="24" 
        fontFamily="system-ui, -apple-system, sans-serif" 
        fontSize="18" 
        fontWeight="800" 
        fill={textColor}
      >
        RUG
      </text>
      
      {/* SHIELD */}
      <text 
        x="82" 
        y="24" 
        fontFamily="system-ui, -apple-system, sans-serif" 
        fontSize="18" 
        fontWeight="800" 
        fill={brandColor}
      >
        SHIELD
      </text>
    </svg>
  );
}

export default Logo;
